import { combineReducers } from "redux";
import applicationReducer from "app/application/reducer";
import contactUsReducer from "./contactUs/reducer";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
export const appReducer = combineReducers({
    app: applicationReducer,
    contactUs: contactUsReducer,
});
